import { ProcessingJob, ProcessingJobAbstract } from './proccesingJobs';
import { Workflow } from './workflow';

export interface DocumentGroup {
  documents: DocumentInfo[];
  groupName: string;
  groupWorkflow?: Workflow;
  documentWorkflow?: Workflow;
  processingJob?: ProcessingJob;
  externalDataSource: string;
  documentIdsToExtract: string[];
  id: string;
}

export interface DocumentGroupAbstract {
  documents: ProcessingJobAbstract[];
  groupName: string;
  workflowId: string;
  createdAt: Date;
  updatedAt: Date;
  deleted: boolean;
  documentGroupId: string;
  externalDataSource: string;
  documentIdsToExtract: string[];
}

export interface DocumentGroupRequest {
  groupName: string;
  workflowId: string | undefined;
}

export interface DocumentInfo {
  processingJobId: string;
  documentId: string | undefined;
}

export interface DocumentGroupResponse {
  processingJobId: string;
  documentId: string;
}

export interface DataRow {
  key: string;
  rowValues: RowValue[];
}

export interface RowValue {
  value: string;
  matchType: MatchType;
}

export enum MatchType {
  NotApplicable = -1,
  FullMatch = 0,
  PartialMatch = 1,
  NoMatch = 2,
}
